const SIGN_IN_DES_KEY='bewemp2020'
const COMMON_DES_KEY='L5kk44Cw4UUg60uB'
const ACCESS_TOKEN_KEY='AccessToken'

export {
  SIGN_IN_DES_KEY,
  COMMON_DES_KEY,
  ACCESS_TOKEN_KEY
}